import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9ef64d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = {
  key: 0,
  class: "page-item active hide-in-print"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_links",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "page-item hide-in-print"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-navigation_pfeil_rechts",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_ctx.active > 1)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('changed', _ctx.active - 1)), ["prevent"])),
            class: "btn btn-brand1"
          }, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('common.pagingPrev')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.max, (page, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: _normalizeClass([{ 'active': _ctx.active === page }, "page-item"])
      }, [
        _createElementVNode("button", {
          onClick: _withModifiers(($event: any) => (_ctx.$emit('changed', page)), ["prevent"]),
          class: _normalizeClass(["btn", _ctx.active === page ? 'btn-brand1' : 'btn-outline-brand1'])
        }, _toDisplayString(page), 11, _hoisted_5)
      ], 2))
    }), 128)),
    (_ctx.active < _ctx.max)
      ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('changed', _ctx.active + 1)), ["prevent"])),
            class: "btn btn-outline-brand1"
          }, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('common.pagingNext')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}